export const setCookiesAccepted = (store, boolean) => {
  store.setState({ cookiesAccepted: boolean });
};

export const setUserUnits = (store, units) => {
  store.setState({ userUnits: units });
};

export const setUserPlan = (store, string) => {
  store.setState({ userPlan: string });
};

export const setNetworkState = (store, state) => {
  store.setState({ networkState: state });
};

export const setSnackbarMessage = (store, options = { message: '', severiy: 'info' }) => {
  store.setState({
    globalSnackbar: {
      display: true,
      message: options.message,
      severity: options.severity,
    },
  });
};

export const closeSnackbar = (store) => {
  store.setState({ globalSnackbar: { display: false, message: '', severity: 'info' } });
};

export const setUserRoles = (store, anArray) => {
  store.setState({ roles: anArray });
};

export const setUserStatus = (store, status) => {
  store.setState({ userStatus: status });
};

export const setVolumeConversionMethod = (store, method) => {
  store.setState({ volumeConversionMethod: method });
};

export const setVolumeConversionEnabled = (store, boolean) => {
  store.setState({ volumeConversionEnabled: boolean });
};

export const setActiveOrganization = (store, organization) => {
  store.setState({ activeOrganization: organization });
};

export const setTransporterNames = (store, array) => {
  store.setState({ transporterNamesSearched: true, transporterNames: array });
};

export const setPureAlcoConversionOperationButtom = (store, boolean) => {
  store.setState({ pureAlcoConversionOperationButton: boolean });
};
